import type { Placement, Origin, PlacementWithAlignment, PlacementWitDashAlignment } from './types';

export const ANCHOR_ORIGIN_MAP: Record<Placement, Origin> = {
  right: 'origin-left',
  left: 'origin-right',
  top: 'origin-bottom',
  bottom: 'origin-top',
};

export const PLACEMENT_MAP: Record<PlacementWitDashAlignment, PlacementWithAlignment> = {
  'top-start': 'top start',
  'top-end': 'top end',
  'right-start': 'right start',
  'right-end': 'right end',
  'bottom-start': 'bottom start',
  'bottom-end': 'bottom end',
  'left-start': 'left start',
  'left-end': 'left end',
};
